import { v4 as uuidv4 } from "uuid";
import { Button, Dropdown, Upload, Tooltip, Modal, notification } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import {
  faIndustry,
  faCalculator,
  faChartPie,
  faProjectDiagram,
  faSquareCheck,
  faSeedling,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import {
  // 產出報表
  GETLCADATAREPORT_API,
  GETLCADATAREPORT_III_API,
  GETLCALISTREPORT_API,
  GETLCAREPORT_API,
  GETLCARISKASSESSMENTREPORT_API,
  GETALLREPORT_API,
  GETMERGEDLCALISTREPORT_API,
  GETMERGEDLCAREPORT_API,
  VERIFYORGANIZATION_API,
  UPLOAD_REFERENCE_API,
  UPLOAD_GREENWORKFILE_API,
  GETLCADETAIL_API,
  UPLOAD_REPORT_API,
  GETEXPORTREPORT_API,
  EXPORT_WARMRECORD_API,
  GETINVESTIGATETEMPLATELCAID_API,
  POSTINVESTIGATEAPPLICATION_API,
} from "@CON";
import {
  downloadGreenhouseGasInventorySample,
  downloadReferenceFile,
  messageGenerator,
  downloadLCA,
} from "@UTIL";
import { store, getLCA } from "@STORE";
import { useRef, useState } from "react";
import { UploadOutlined } from "@ant-design/icons";

const GreenhouseDropdown = ({ disabled, setLoading }) => {
  const { t } = useTranslation();
  const greenhouseDropdownItems = [
    {
      key: "sample",
      label: (
        <Button
          key="sample"
          type="primary"
          size="large"
          className="w-100"
          onClick={() => {
            downloadGreenhouseGasInventorySample(
              "/Browser_Local/WebFilesRoot/溫室氣體盤查作業規範.docx"
            );
          }}
        >
          {t("Buttons.Template")}
        </Button>
      ),
    },
    {
      key: "upload",
      label: (
        <Upload
          key="upload"
          className="GreenhouseUploadBtn"
          name="GreenhouseGasInventoryWorkFile"
          action={(file) => {
            return Promise.resolve(UPLOAD_REFERENCE_API);
          }}
          showUploadList={false}
          onChange={async (e) => {
            const {
              project: { LCAInfo },
            } = store.getState();
            if (e?.file?.status && e.file?.status === "error") {
              messageGenerator({ content: t("MessageText.Upload failed") });
            } else if (e && e.file?.status === "done") {
              const res = await axios.post(UPLOAD_GREENWORKFILE_API, {
                LCAID: LCAInfo.ID,
                GreenhouseGasInventoryWorkFileUrl: e.file?.response[0],
              });
              if (res.result === "success") {
                const LCADetail = await axios.get(
                  `${GETLCADETAIL_API}/${LCAInfo?.ID}`
                );
                const { LCAobj } = LCADetail;
                store.dispatch(getLCA(LCAobj));
                messageGenerator({
                  result: "success",
                  content: t("MessageText.Upload successful"),
                });
              } else {
                messageGenerator({ content: t("MessageText.Upload failed") });
              }
            }
          }}
        >
          <Button
            key="upload"
            type="primary"
            size="large"
            className="w-100"
            disabled={store.getState().project.LCADisabled}
          >
            {t("Buttons.Upload")}
          </Button>
        </Upload>
      ),
    },
    {
      key: "download",
      label: (
        <Button
          type="primary"
          size="large"
          className="w-100"
          key="download"
          onClick={async () => {
            setLoading(true);
            const {
              project: { LCAInfo },
            } = store.getState();

            if (LCAInfo?.GreenhouseGasInventoryWorkFileUrl) {
              downloadReferenceFile([
                LCAInfo?.GreenhouseGasInventoryWorkFileUrl,
              ]);
            }
            setLoading(false);
          }}
        >
          {t("Buttons.File")}
        </Button>
      ),
    },
  ];
  return (
    <Dropdown
      disabled={disabled}
      menu={{
        items: greenhouseDropdownItems,
      }}
      trigger={["click"]}
      placement="bottom"
      arrow={{
        pointAtCenter: true,
      }}
    >
      <button className="btn bg-info text-white rounded-3 py-3 my-1 fs-6">
        {t("Project.Greenhouse gas management procedure")}
      </button>
    </Dropdown>
  );
};

const ReportDropdown = ({ disabled, setLoading }) => {
  const { t } = useTranslation();
  const reportDropdownItems = [
    {
      key: "sample",
      label: (
        <Button
          key="sample"
          type="primary"
          size="large"
          className="w-100"
          onClick={() => {
            downloadGreenhouseGasInventorySample(
              "/Browser_Local/WebFilesRoot/組織型報告書-模版.docx"
            );
          }}
        >
          {t("Buttons.Template")}
        </Button>
      ),
    },
    {
      key: "upload",
      label: (
        <Upload
          key="upload"
          className="GreenhouseUploadBtn"
          name="GreenhouseGasInventoryWorkFile"
          action={(file) => {
            return Promise.resolve(UPLOAD_REPORT_API);
          }}
          showUploadList={false}
          onChange={async (e) => {
            if (e?.file?.status && e.file?.status === "error") {
              messageGenerator({ content: t("MessageText.Upload failed") });
            } else if (e && e.file?.status === "done") {
              if (e?.file?.response.Success) {
                messageGenerator({
                  result: "success",
                  content: t("MessageText.Upload successful"),
                });
              } else {
                messageGenerator({ content: t("MessageText.Upload failed") });
              }
            }
          }}
          disabled={store.getState().project.LCADisabled}
        >
          <Tooltip title={t("FormMsg.FileExtensionsDOC")}>
            <Button
              key="upload"
              type="primary"
              size="large"
              className="w-100"
              style={{ height: "40px", width: "100%" }}
              disabled={store.getState().project.LCADisabled}
            >
              {t("Buttons.TemplateUp")}
            </Button>
          </Tooltip>
        </Upload>
      ),
    },
    {
      key: "download",
      label: (
        <Button
          type="primary"
          size="large"
          className="w-100"
          key="download"
          onClick={async () => {
            setLoading(true);
            const {
              project: {
                LCAInfo: { ID },
              },
            } = store.getState();

            const res = await axios.post(`${GETLCAREPORT_API}/${ID}`);
            if (res?.result === "success" && res?.data) {
              const fileUrl = res?.data.split(",");
              // 呼叫下載函數
              downloadLCA(fileUrl);
              // 顯示成功訊息
              messageGenerator({
                result: "success",
                content: t("MessageText.Download successful"),
              });
            } else {
              // 顯示錯誤訊息
              messageGenerator({
                result: "error",
                content: res?.errMsg,
              });
            }
            setLoading(false);
          }}
        >
          {t("Buttons.File")}
        </Button>
      ),
    },
  ];

  return (
    <Dropdown
      disabled={disabled}
      menu={{
        items: reportDropdownItems,
      }}
      trigger={["click"]}
      placement="bottomLeft"
      arrow={{
        pointAtCenter: true,
      }}
    >
      <button className="btn bg-info text-white rounded-3 py-3 my-1 fs-6">
        {t("Project.Report")}
      </button>
    </Dropdown>
  );
};

const VerificationDropdown = ({ disabled, setLoading }) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const [inventoryFile, setInventoryFile] = useState([]);
  const [reportFile, setReportFile] = useState([]);
  const [applicationFile, setApplicationFile] = useState([]);
  const {
    project: {
      LCAInfo: { ID },
      LCADisabled,
    },
  } = store.getState();

  const handleOk = () => {
    Modal.confirm({
      title: <div style={{ fontSize: "22px" }}>{t("Project.Confirmupload")}</div>,
      content: (
        <div style={{ fontSize: "18px" }}>
          {t("Project.Confirmuploadtext")}
        </div>
      ),
      okText: <div style={{ fontSize: "16px" }}>{t("Buttons.Confirm")}</div>,
      cancelText: (
        <div style={{ fontSize: "16px" }}>{t("Buttons.Cancel")}</div>
      ),
      onOk: async () => {
        console.log('inventoryFile',inventoryFile,reportFile,applicationFile);
        
        if (
          inventoryFile.length === 0 ||
          reportFile.length === 0 ||
          applicationFile.length === 0
        ) {
          messageGenerator({
            result: "error",
            content: t("MessageText.Update all files"),
          });
          return;
        }

        const formData = new FormData();

        formData.append("inventory", inventoryFile[0].originFileObj);
        formData.append("report", reportFile[0].originFileObj);
        formData.append("application", applicationFile[0].originFileObj);

        try {
          const res = await axios.post(
            `${POSTINVESTIGATEAPPLICATION_API}/${ID}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          if (res?.result === "success") {
            messageGenerator({
              result: "success",
              content: t("MessageText.Upload successful"),
            });
          } else {
            messageGenerator({
              result: "error",
              content: t("MessageText.Upload failed"),
            });
          }
        } catch (error) {
          messageGenerator({
            result: "error",
            content: t("MessageText.Upload failed"),
          });
        } finally {
          setModalOpen(false); // 關閉 Modal
        }
      },
    });
  };

  const handleInventoryChange = (info) => {
    setInventoryFile(info.fileList);
  };

  const handleReportChange = (info) => {
    setReportFile(info.fileList);
  };

  const handleApplicationChange = (info) => {
    setApplicationFile(info.fileList);
  };

  const actionProps = {
    action: (file) => Promise.resolve(), // 空的 Promise.resolve
    beforeUpload: () => false, // 阻止預設上傳
    showUploadList: true, // 顯示上傳列表
    maxCount: 1, // 最多上傳一個
  };

  const verificationDropdownItems = [
    {
      key: "download",
      label: (
        <Button
          type="primary"
          size="large"
          className="w-100"
          key="download"
          onClick={async () => {
            setLoading(true);

            const res = await axios.post(
              `${GETINVESTIGATETEMPLATELCAID_API}/${ID}`
            );
            if (res?.result === "success" && res?.data) {
              const fileUrl = res?.data.split(",");
              // 呼叫下載函數
              downloadLCA(fileUrl);
              // 顯示成功訊息
              messageGenerator({
                result: "success",
                content: t("MessageText.Download successful"),
              });
            } else {
              // 顯示錯誤訊息
              messageGenerator({
                result: "error",
                content: res?.errMsg,
              });
            }
            setLoading(false);
          }}
        >
          {t("Buttons.Application")}
        </Button>
      ),
    },
    {
      key: "upload",
      label: (
        <Button
          key="upload"
          type="primary"
          size="large"
          className="w-100"
          style={{ height: "40px", width: "100%" }}
          disabled={LCADisabled}
          onClick={() => setModalOpen(true)}
        >
          {t("Buttons.UploadandSend")}
        </Button>
      ),
    },
  ];

  return (
    <>
      <Dropdown
        disabled={disabled}
        menu={{
          items: verificationDropdownItems,
        }}
        trigger={["click"]}
        placement="bottom"
        arrow={{
          pointAtCenter: true,
        }}
      >
        <button className="btn bg-info text-white rounded-3 py-3 my-1 fs-6">
          {t("Project.External verification")}
        </button>
      </Dropdown>
      <Modal
        title={t("Buttons.Upload")}
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        onOk={handleOk}
      >
        <Upload
          {...actionProps}
          name="inventory"
          onChange={handleInventoryChange}
          fileList={inventoryFile}
        >
          <span>{t("Project.Inventory list")} : </span>
          <Button icon={<UploadOutlined />}>{t("Buttons.Upload")}</Button>
        </Upload>
        <Upload
          {...actionProps}
          name="report"
          onChange={handleReportChange}
          fileList={reportFile}
        >
          <span>{t("Project.Report")} : </span>
          <Button icon={<UploadOutlined />}>{t("Buttons.Upload")}</Button>
        </Upload>
        <Upload
          {...actionProps}
          name="application"
          onChange={handleApplicationChange}
          fileList={applicationFile}
        >
          <span>{t("Project.Application")} : </span>
          <Button icon={<UploadOutlined />}>{t("Buttons.Upload")}</Button>
        </Upload>
      </Modal>
    </>
  );
};

const projectFlowList = (ID = "", SiteUser) => [
  {
    key: uuidv4(),
    category: "Boundary setting",
    icon: <FontAwesomeIcon icon={faIndustry} size="2x" />,
    subCategory: [
      {
        subKey: "boundary",
        text: "Boundary setting",
        redirect: "/project/boundary",
        isShow: true, // 用來解決不再功能列表上但須顯示的問題
      },
      {
        subKey: "sbtisetting",
        text: "sbtisetting",
        redirect: "/project/boundary/sbtisetting",
      },
      {
        subKey: "project-management",
        text: "project-management",
        redirect: "/project/boundary/project-management",
        isShow: true,
      },
    ],
  },
  {
    key: uuidv4(),
    category: "Emissions calculation",
    icon: <FontAwesomeIcon icon={faCalculator} size="2x" />,
    subCategory: [
      {
        subKey: "calculate",
        text: "Emission data input",
        redirect: "/project/calculate",
        isShow: true,
      },
      {
        subKey: "risk",
        text: "Significant analysis",
        redirect: `/project/risk/${ID ?? ""}`,
      },
    ],
  },
  {
    key: uuidv4(),
    category: "Inventory results",
    icon: <FontAwesomeIcon icon={faChartPie} size="2x" />,
    subCategory: [
      // { subKey: uuidv4(), text: "溫室氣體排放統計表", redirect: "" },
      {
        subKey: "analyse",
        text: "Analyse",
        redirect: "/project/analyse",
      },
      {
        subKey: "compare",
        text: "compare",
        redirect: "/project/compare",
      },
      {
        subKey: "LCADataReport", // 盤查表
        text: "Inventory checklist",
        redirect: "",
        downloadApi:
          SiteUser === "III" ? GETLCADATAREPORT_III_API : GETLCADATAREPORT_API,
      },
      {
        subKey: "LCARiskAssessmentReport", // 風險評估報表
        text: "Risk assessment report",
        redirect: "",
        downloadApi: GETLCARISKASSESSMENTREPORT_API,
      },
      {
        // 資策會用
        subKey: "ExportReport", // 資策會報表
        text: "ExportReport",
        redirect: "",
        downloadApi: GETEXPORTREPORT_API,
        auth: "III",
      },
      {
        subKey: "LCAListReport", // 盤查清冊
        text: "Inventory list",
        redirect: "",
        downloadApi: GETLCALISTREPORT_API,
      },
      {
        subKey: "LCAReport", // 溫室氣體報告書
        text: <ReportDropdown />,
        Node: ReportDropdown,
        isReactNode: true,
      },
      // {
      //   subKey: "LCAReport",
      //   text: "Inventory report", // 碳盤查報告書
      //   redirect: "",
      //   downloadApi: GETLCAREPORT_API,
      // },
      {
        subKey: "allReport",
        text: "All reports", // 全部報表
        redirect: "",
        downloadApi: GETALLREPORT_API,
      },
      {
        subKey: "mergedLCAListReport",
        text: "Combine inventory lists", // 合併清冊
        redirect: "",
        downloadApi: GETMERGEDLCALISTREPORT_API,
      },
      {
        subKey: "mergedLCAReport", // 合併報告書
        text: "Combine inventory report",
        redirect: "",
        downloadApi: GETMERGEDLCAREPORT_API,
      },
      {
        subKey: "ghgreport",
        text: "GHGreport",
        redirect: "/project/ghgreport",
      },
      {
        subKey: "Environment3.0.0.0",
        text: "Environment3.0.0.0",
        redirect: "",
        downloadApi: EXPORT_WARMRECORD_API,
        isShow: true,
      },
    ],
  },
  {
    key: uuidv4(),
    category: "Standard process",
    icon: <FontAwesomeIcon icon={faProjectDiagram} size="2x" />,
    subCategory: [
      {
        subKey: "GreenhouseGasInventory", // 溫室氣體管理程序
        text: <GreenhouseDropdown />,
        Node: GreenhouseDropdown,
        isReactNode: true,
      },
    ],
  },
  {
    key: uuidv4(),
    category: "Verification",
    icon: <FontAwesomeIcon icon={faSquareCheck} size="2x" />,
    subCategory: [
      {
        subKey: "verification", // 內部驗證
        text: "Internal verification",
        redirect: "/project/verification",
      },
      {
        subKey: "verifyOrganization", // 外部驗證
        text: "External verification",
        Node: VerificationDropdown,
        isReactNode: true,
      },
    ],
  },
  {
    key: uuidv4(),
    category: "Net-zero roadmap planning",
    icon: <FontAwesomeIcon icon={faSeedling} size="2x" />,
    subCategory: [
      {
        subKey: "sbtichart",
        text: "Establish a net-zero roadmap",
        redirect: "/project/sbtichart",
      },
      {
        subKey: "carboncredit",
        text: "Carbon credit",
        redirect: "/project/CarbonCredit",
      },
      // {
      //   subKey: "GHG deduction planning",
      //   text: "GHG deduction planning",
      //   redirect: "",
      // },
    ],
  },
];

export default projectFlowList;
